// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/VectorBack.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/Procent.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public/print.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml;charset=UTF-8,%3Csvg width=%2712%27 height=%2710%27 viewBox=%270 0 12 10%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M1 5L4.2 8L11 1%27 stroke=%27white%27 stroke-width=%272%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.addSingleProductDrawer_drawer__zBB\\+q {
  z-index: 0;
  position: fixed;
  top: 0;
  right: 0;
  width: 85vw;
  height: 100vh;
  background: rgba(249, 249, 249, 1);
  z-index: 1000;
  padding: 50px 32px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.addSingleProductDrawer_header__KGJUg {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
}

.addSingleProductDrawer_content__LcUlP {
  width: 50%;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 12px;
  padding: 24px;
  text-align: left;
}

.addSingleProductDrawer_headerText__UPJUW {
  font-weight: 700;
  font-size: 24px;
  margin-left: 12px;
}

.addSingleProductDrawer_backButton__BDiUQ {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: contain;
  width: 15px;
  height: 16.2px;
  border: none;
  font-size: 16px;
  cursor: pointer;
}

.addSingleProductDrawer_section__JJvmE {
  margin-bottom: 24px;
}

.addSingleProductDrawer_section__JJvmE h3 {
  margin-bottom: 16px;
  font-size: 18px;
  font-weight: 700;
}

.addSingleProductDrawer_grid__8jdcB {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px;
}

.addSingleProductDrawer_input__sOSEr{
  padding: 10px ;
  border: 1px solid rgba(203, 213, 225, 1) ;
  border-radius: 6px ;
  font-size: 14px ;
}

.addSingleProductDrawer_barcodeRow__ss7ws {
  display: flex;
  align-items: center;
  gap: 12px;
}

.addSingleProductDrawer_link__8tMVa {
  background: none;
  border: none;
  color: #1d8752;
  cursor: pointer;
  font-weight: 500;
}

.addSingleProductDrawer_uploadBox__6lb98 {
  display: flex;
}

.addSingleProductDrawer_uploadPlaceholder__5tP2G {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 160px;
  height: 160px;
  border: 1px dashed #ccc;
  border-radius: 8px;
  font-size: 16px;
  color: rgba(29, 135, 82, 1);
  margin-bottom: 8px;
}

.addSingleProductDrawer_uploadPlaceholderPlus__Ovw-K {
  font-size: 40px;
}

.addSingleProductDrawer_uploadInfo__bvfCO {
  font-size: 14px;
  line-height: 24px;
  padding-left: 16px;
}

.addSingleProductDrawer_checkboxRow__C13ad {
  display: flex;
  gap: 24px;
  margin-bottom: 32px;
}

.addSingleProductDrawer_footer__hMPxC {
  display: flex;
  justify-content: flex-end;
}

.addSingleProductDrawer_addButton__pyJ7z {
  background: #1d8752;
  color: white;
  padding: 12px 24px;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
}

.addSingleProductDrawer_procent__VbVGj {
  position: relative;
  display: inline-block;
}

.addSingleProductDrawer_procent__VbVGj::after {
  content: '';
  position: absolute;
  bottom: 11px;
  right: 15px;
  height: 16px;
  width: 16px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-size: contain;
  pointer-events: none;
}

.addSingleProductDrawer_procent__VbVGj input {
  width: 100%;
}

.addSingleProductDrawer_barcodeRowBlock__iDkbz {
  position: relative;
  display: inline-block;
}

.addSingleProductDrawer_barcodeRowBlock__iDkbz::after {
  content: '';
  position: absolute;
  bottom: 10px;
  right: 12px;
  height: 16px;
  width: 16px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-size: contain;
  pointer-events: none;
}

.addSingleProductDrawer_barcodeRowBlock__iDkbz input {
  width: 310px;
}

.addSingleProductDrawer_barcodeRowRandom__Wn1Rq {
  color: rgba(29, 135, 82, 1);
  font-size: 16px;
  margin-top: 30px;
}

.addSingleProductDrawer_clearButton__E2mdF {
  background: #1d8752;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 6px 12px;
  cursor: pointer;
  font-size: 14px;
  transition: background 0.2s ease;
}

.addSingleProductDrawer_clearButton__E2mdF:hover {
  background: #d32f2f;
}


.addSingleProductDrawer_previewImage__gznxP {
  width: 100%;
  height: auto;
  object-fit: cover;
  border-radius: 8px;
}

.addSingleProductDrawer_checkboxContainer__gMqzT {
  display: flex;
  position: relative;
  align-items: center;
  cursor: pointer;
}

.addSingleProductDrawer_checkboxContainer__gMqzT input {
  opacity: 0;
  width: 0;
  height: 0;
}

.addSingleProductDrawer_checkboxContainer__gMqzT p {
  margin-left: 6px;
}

.addSingleProductDrawer_customCheckbox__Y\\+mMv {
  position: absolute;
  top: 0;
  left: 0;
  height: 18px;
  width: 18px;
  background-color: white;
  border: 2px solid #1D8752;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.addSingleProductDrawer_checkboxContainer__gMqzT input:checked + .addSingleProductDrawer_customCheckbox__Y\\+mMv {
  background-color: #1D8752;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-repeat: no-repeat;
  background-position: center;
}
`, "",{"version":3,"sources":["webpack://./src/styles/addSingleProductDrawer.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,eAAe;EACf,MAAM;EACN,QAAQ;EACR,WAAW;EACX,aAAa;EACb,kCAAkC;EAClC,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yDAA6C;EAC7C,4BAA4B;EAC5B,wBAAwB;EACxB,WAAW;EACX,cAAc;EACd,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,cAAc;EACd,yCAAyC;EACzC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,WAAW;EACX,yDAA4C;EAC5C,4BAA4B;EAC5B,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,WAAW;EACX,yDAA0C;EAC1C,4BAA4B;EAC5B,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yDAAsO;EACtO,4BAA4B;EAC5B,2BAA2B;AAC7B","sourcesContent":[".drawer {\n  z-index: 0;\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: 85vw;\n  height: 100vh;\n  background: rgba(249, 249, 249, 1);\n  z-index: 1000;\n  padding: 50px 32px;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.content {\n  width: 50%;\n  background-color: rgba(255, 255, 255, 1);\n  border-radius: 12px;\n  padding: 24px;\n  text-align: left;\n}\n\n.headerText {\n  font-weight: 700;\n  font-size: 24px;\n  margin-left: 12px;\n}\n\n.backButton {\n  background-image: url(/public/VectorBack.png);\n  background-repeat: no-repeat;\n  background-size: contain;\n  width: 15px;\n  height: 16.2px;\n  border: none;\n  font-size: 16px;\n  cursor: pointer;\n}\n\n.section {\n  margin-bottom: 24px;\n}\n\n.section h3 {\n  margin-bottom: 16px;\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 16px;\n}\n\n.input{\n  padding: 10px ;\n  border: 1px solid rgba(203, 213, 225, 1) ;\n  border-radius: 6px ;\n  font-size: 14px ;\n}\n\n.barcodeRow {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.link {\n  background: none;\n  border: none;\n  color: #1d8752;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.uploadBox {\n  display: flex;\n}\n\n.uploadPlaceholder {\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 160px;\n  height: 160px;\n  border: 1px dashed #ccc;\n  border-radius: 8px;\n  font-size: 16px;\n  color: rgba(29, 135, 82, 1);\n  margin-bottom: 8px;\n}\n\n.uploadPlaceholderPlus {\n  font-size: 40px;\n}\n\n.uploadInfo {\n  font-size: 14px;\n  line-height: 24px;\n  padding-left: 16px;\n}\n\n.checkboxRow {\n  display: flex;\n  gap: 24px;\n  margin-bottom: 32px;\n}\n\n.footer {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.addButton {\n  background: #1d8752;\n  color: white;\n  padding: 12px 24px;\n  border: none;\n  border-radius: 6px;\n  font-size: 16px;\n  cursor: pointer;\n}\n\n.procent {\n  position: relative;\n  display: inline-block;\n}\n\n.procent::after {\n  content: '';\n  position: absolute;\n  bottom: 11px;\n  right: 15px;\n  height: 16px;\n  width: 16px;\n  background-image: url('/public/Procent.png');\n  background-repeat: no-repeat;\n  background-size: contain;\n  pointer-events: none;\n}\n\n.procent input {\n  width: 100%;\n}\n\n.barcodeRowBlock {\n  position: relative;\n  display: inline-block;\n}\n\n.barcodeRowBlock::after {\n  content: '';\n  position: absolute;\n  bottom: 10px;\n  right: 12px;\n  height: 16px;\n  width: 16px;\n  background-image: url('/public/print.png');\n  background-repeat: no-repeat;\n  background-size: contain;\n  pointer-events: none;\n}\n\n.barcodeRowBlock input {\n  width: 310px;\n}\n\n.barcodeRowRandom {\n  color: rgba(29, 135, 82, 1);\n  font-size: 16px;\n  margin-top: 30px;\n}\n\n.clearButton {\n  background: #1d8752;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  padding: 6px 12px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background 0.2s ease;\n}\n\n.clearButton:hover {\n  background: #d32f2f;\n}\n\n\n.previewImage {\n  width: 100%;\n  height: auto;\n  object-fit: cover;\n  border-radius: 8px;\n}\n\n.checkboxContainer {\n  display: flex;\n  position: relative;\n  align-items: center;\n  cursor: pointer;\n}\n\n.checkboxContainer input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.checkboxContainer p {\n  margin-left: 6px;\n}\n\n.customCheckbox {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 18px;\n  width: 18px;\n  background-color: white;\n  border: 2px solid #1D8752;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.checkboxContainer input:checked + .customCheckbox {\n  background-color: #1D8752;\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3Csvg width='12' height='10' viewBox='0 0 12 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 5L4.2 8L11 1' stroke='white' stroke-width='2'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"drawer": `addSingleProductDrawer_drawer__zBB+q`,
	"header": `addSingleProductDrawer_header__KGJUg`,
	"content": `addSingleProductDrawer_content__LcUlP`,
	"headerText": `addSingleProductDrawer_headerText__UPJUW`,
	"backButton": `addSingleProductDrawer_backButton__BDiUQ`,
	"section": `addSingleProductDrawer_section__JJvmE`,
	"grid": `addSingleProductDrawer_grid__8jdcB`,
	"input": `addSingleProductDrawer_input__sOSEr`,
	"barcodeRow": `addSingleProductDrawer_barcodeRow__ss7ws`,
	"link": `addSingleProductDrawer_link__8tMVa`,
	"uploadBox": `addSingleProductDrawer_uploadBox__6lb98`,
	"uploadPlaceholder": `addSingleProductDrawer_uploadPlaceholder__5tP2G`,
	"uploadPlaceholderPlus": `addSingleProductDrawer_uploadPlaceholderPlus__Ovw-K`,
	"uploadInfo": `addSingleProductDrawer_uploadInfo__bvfCO`,
	"checkboxRow": `addSingleProductDrawer_checkboxRow__C13ad`,
	"footer": `addSingleProductDrawer_footer__hMPxC`,
	"addButton": `addSingleProductDrawer_addButton__pyJ7z`,
	"procent": `addSingleProductDrawer_procent__VbVGj`,
	"barcodeRowBlock": `addSingleProductDrawer_barcodeRowBlock__iDkbz`,
	"barcodeRowRandom": `addSingleProductDrawer_barcodeRowRandom__Wn1Rq`,
	"clearButton": `addSingleProductDrawer_clearButton__E2mdF`,
	"previewImage": `addSingleProductDrawer_previewImage__gznxP`,
	"checkboxContainer": `addSingleProductDrawer_checkboxContainer__gMqzT`,
	"customCheckbox": `addSingleProductDrawer_customCheckbox__Y+mMv`
};
export default ___CSS_LOADER_EXPORT___;
